export default "__VITE_ASSET__DYolFCdA__"